<article *ngIf="data">
    <div class="container">
        <div
            *ngIf="data.headlineText || data.link"
            class="row"
            [ngClass]="[data.alignment === alignment.Center ? 'center' : '']"
        >
            <div
                class="col-10 col-md-4 col-xl-3"
                [ngClass]="[data.alignment === alignment.Left ? 'offset-1 offset-md-2' : '']"
            >
                <div class="content" [ngClass]="{ white: data.textColor === textColor.White }" appInterceptLinks>
                    <div class="headline">
                        <app-spot-headline *ngIf="data.headlineText" [index]="data.spotIndex" section="h1">
                            {{ data.headlineText }}
                        </app-spot-headline>
                    </div>
                    <a
                        *ngIf="data.link"
                        [href]="data.link.url"
                        class="kk-btn kk-btn_secondary"
                        [target]="data.link.target || '_self'"
                        >{{ data.link.name }}</a
                    >
                </div>
            </div>
        </div>
        <div class="image-wrapper">
            <ng-container *ngIf="data.image && data.image.src">
                <app-image
                    [image]="data.image"
                    [width]="1568"
                    [index]="data.spotIndex"
                    [height]="520"
                    [style]="{
                        objectFit: 'cover',
                        objectPosition: data.image.focalPoint | imageFocalPoint : data.alignment,
                        height: '100%'
                    }"
                    [intersectionOptions]="{ threshold: 0 }"
                    crop="crop"
                ></app-image>
            </ng-container>
        </div>
    </div>
</article>
<div class="container" *ngIf="data.showUsps">
    <app-usp></app-usp>
</div>
